<template>
  <div>
    <!-- Kids Cards -->
    <v-row class="kids p-3">
      <v-col
        cols="6"
        sm="3"
        class="py-0 mb-4"
        v-for="(st, index) in studentInfo"
        :key="index"
      >
        <v-row
          class="kid"
          :class="st.active == true ? 'active' : ''"
          @click="MakeHimActive(index)"
        >
          <v-col cols="4">
            <img
              :src="st.logo"
              v-if="st.logo"
              alt="student image"
              class="student-image"
            />
            <img
              v-else
              src="../../assets/avatar.png"
              class="student-image"
              alt=""
            />
          </v-col>
          <v-col cols="8">
            <p class="student-name">{{ st.name }}</p>
          </v-col>
          <v-col cols="6" class="py-0" v-if="st.grade">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p class="student-grade mb-1" v-bind="attrs" v-on="on">
                  {{ splitString(st.grade) }}
                </p>
              </template>
            </v-tooltip>
            <span>{{ st.grade }}</span>
          </v-col>

          <v-col cols="6" class="text-right py-0" v-if="st.class">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p
                  class="text-right student-class mb-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ splitString(st.class) }}
                </p>
              </template>
            </v-tooltip>
            <span>{{ st.class }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="card height-auto v-application--is-ltr text-left">
      <v-row>
        <v-col cols="12" md="4">
          <p class="title main-color" style="text-align: left">
            {{ $i18n.t("Student Marks") }}
          </p>
        </v-col>
        <v-col cols="12" md="4"> </v-col>
        <v-col cols="12" md="4">
          <div class="text-right pt-2">
            <v-btn
              class="modal-btn-save- main-color text-capitalize"
              @click="printReportCard()"
              v-if="showReport"
              style="border: 1px solid"
              large
            >
              {{ $t("Report Card") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <div class="card-body">
        <v-row>
          <v-col md="6" cols="12">
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Semester</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('semester')"
                  :items="semesters"
                  item-text="name"
                  item-value="id"
                  v-model="selectedSemester"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="6" cols="12">
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Quarter</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Quarter')"
                  :items="quarters"
                  item-text="name"
                  item-value="id"
                  v-model="selectedQuarter"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <hr />
        <!-- subjects -->
        <div v-if="Object.keys(data).length > 0">
          <v-row v-for="subject in data" :key="subject">
            <v-col cols="12" md="12">
              <v-card class="card-container">
                <v-card-text style="padding: 15px 20px">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <v-row>
                          <v-col md="8" cols="12">
                            <h3 class="title-panel">
                              {{ subject.subject_title }}
                            </h3>
                          </v-col>
                          <v-col md="3" cols="12"> </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background: #fafafa">
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Exam Name") }}
                                </th>

                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Qualifier") }}
                                </th>

                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Activity") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Date") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Start Time") }}
                                </th>

                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Duration hr:min") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Type") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Mark") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- v-for="(item, index2) in subject.exams" :key="index2" -->
                              <tr
                                v-for="(item, index2) in subject.exams"
                                :key="index2"
                              >
                                <!-- <td style="font-size: small">
                              {{ item.subject }}
                            </td>
                            <td style="font-size: small">
                              {{ item.subject_type }}
                            </td>
                            <td></td> -->
                                <td>
                                  <!-- <router-link
                                    :to="'/examTimer/' + item.exam_id"
                                    v-if="
                                      item.exam_date_link_active == 1 &&
                                      !parent &&
                                      !item.confirmed &&
                                      item.online_exam
                                    "
                                    >{{ item.exam_name }}</router-link
                                  > -->
                                  <a
                                    @click="routeToVeiwExamAnswer(item.exam_id)"
                                    v-if="
                                      item.confirmed &&
                                      item.online_exam &&
                                      !parent
                                    "
                                    style="color: #1976d2"
                                    >{{ item.exam_name }}</a
                                  >
                                  <p v-else>
                                    {{ item.exam_name }}
                                  </p>
                                  <!-- <p v-if="parent && !item.confirmed">
                                    {{ item.exam_name }}
                                  </p> -->
                                </td>
                                <td>{{ item.qualifier_title }}</td>
                                <td>{{ item.activity }}</td>
                                <td>{{ item.exam_date }}</td>
                                <td>{{ item.start_time }}</td>
                                <td>{{ item.duration }}</td>
                                <td>{{ item.type }}</td>
                                <td>{{ item.mark ? item.mark : "" }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <h2 v-else style="color: #646464">No Data Available</h2>

        <!-- general exams -->
        <div v-if="generalExams.length > 0">
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="card-container general-exams">
                <v-card-text style="padding: 15px 20px">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <v-row>
                          <v-col md="8" cols="12">
                            <h3 class="title-panel">
                              General Exams
                              <br />
                              <span style="font-size: 18px"
                                >(Not calculated in report card)</span
                              >
                            </h3>
                          </v-col>
                          <v-col md="3" cols="12"> </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr style="background: #fafafa">
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Exam Name") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Qualifier") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Subject") }}
                                </th>

                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Date") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Start Time") }}
                                </th>

                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Duration hr:min") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Type") }}
                                </th>
                                <th
                                  class="text-left bold"
                                  style="font-size: 14px !important"
                                >
                                  {{ $t("Mark") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <!--  -->
                              <tr
                                v-for="(gitem, index3) in generalExams"
                                :key="index3"
                              >
                                <!-- <td>Exam Name</td>
                                <td>Oral</td>
                                <td>English</td>
                                <td>12-10-2023</td>
                                <td>01:30 PM</td>
                                <td>02:00</td>
                                <td>Ofline</td>
                                <td>50/50</td> -->
                                <td>
                                  <a
                                    @click="
                                      routeToVeiwExamAnswer(gitem.exam_id)
                                    "
                                    v-if="gitem.confirmed && gitem.online_exam"
                                    style="color: #1976d2"
                                    >{{ gitem.exam_name }}</a
                                  >
                                  <p v-else>
                                    {{ gitem.exam_name }}
                                  </p>
                                </td>
                                <td>{{ gitem.qualifier_title }}</td>
                                <td>{{ gitem.subject_name }}</td>

                                <td>{{ gitem.exam_date }}</td>
                                <td>{{ gitem.start_time }}</td>
                                <td>{{ gitem.duration }}</td>
                                <td>{{ gitem.type }}</td>
                                <td>{{ gitem.mark ? gitem.mark : "" }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- /general exams -->

        <div class="text-center pt-2">
          <v-snackbar
            v-model="snack"
            :timeout="snackTime"
            :color="snackColor"
            :right="true"
            :top="true"
          >
            <!-- {{ snackText }} -->

            <span class="white--text">{{ snackText }}</span>

            <v-btn text @click="snack = false">{{ $t("Close") }}</v-btn>
          </v-snackbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ACL from "../../acl";
import axios from "axios";
export default {
  name: "MyExams",
  components: {},
  data() {
    return {
      parent: ACL.Role("Parent"),
      showReport: false,
      options: {
        itemsPerPage: 15,
      },
      snack: "",
      selectedSemester: "",
      selectedQuarter: "",
      semesters: [],
      quaretrs: [],
      dialogReset: false,
      snackTime: 3000,
      snackColor: "",
      snackText: "",
      filterMenu: false,
      loading: true,
      formTitle: "",
      selected: [],
      data: [],
      generalExams: [],
      title: this.$i18n.t("Student Marks"),
      studentInfo: [],
      items: [],
      quarters: [],
      subjects: [],
      qualifierList: [],
      filter: {
        quarter_id: "",
        academic_grade_subject_id: "",
        qualifier_id: "",
        student_id: "",
        student_ids: [],
      },
      selectedStudent_id: "",
      search: "",
      circle: true,
      page: 1,
      length: "",
      totalVisible: "",
      totalItems: "",
      AddEditdialog: false,
      editedIndex: -1,
      confirmDialoag: false,
    };
  },
  watch: {
    // "$route.query": {
    //   handler() {
    //     if (this.$route.query.page !== undefined) {
    //       this.page = Number(this.$route.query.page);
    //       this.getAllData(this.$route.query.page);
    //     } else {
    //       this.getAllData(1);
    //     }
    //   },
    //   deep: true,
    // },
    // page: function () {
    //   this.$router.push(
    //     {
    //       path: "/myxams/?page=" + this.page,
    //     },
    //     () => {}
    //   );
    // },
    // search: {
    //   handler() {
    //     this.page = 1;
    //     this.getAllData(this.page);
    //   },
    //   deep: true,
    // },
    selectedSemester: {
      handler() {
        // this.page = 1;
        this.getQuarters();
      },
      deep: true,
    },
    selectedQuarter: {
      handler() {
        // this.page = 1;
        this.getAllData();
      },
      deep: true,
    },
  },
  methods: {
    printReportCard() {
      let studentIdIfChild = this.selectedStudent_id
        ? "/" + this.selectedStudent_id
        : "";
      console.log(
        this.getApiUrl +
          "/print-student-report-card/" +
          this.selectedQuarter +
          studentIdIfChild
      );
      axios
        .get(
          this.getApiUrl +
            "/performance/print-student-report-card/" +
            this.selectedQuarter +
            studentIdIfChild,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              //the token is a variable which holds the token
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            let printLink = response.data.data;
            window.open(printLink, "_blank");
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    getSemesters() {
      axios
        .get(this.getApiUrl + "/performance/getSemestersFilter", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          // console.log(response.data.data);
          this.semesters = response.data.data;
          this.semesters.forEach((semester) => {
            if (semester.isCurrentSemesterId) {
              this.selectedSemester = semester.id;
            }
          });
        });
    },
    routeToVeiwExamAnswer(examId) {
      // "/myexams/view/myAnswers/:examId"
      if (this.parent) {
        this.$router.push(
          {
            path:
              "/myexams/view/myAnswers/" +
              examId +
              "?student_id=" +
              this.selectedStudent_id,
          },
          () => {}
        );
      } else {
        this.$router.push(
          {
            path: "/myexams/view/myAnswers/" + examId,
          },
          () => {}
        );
      }
    },
    MakeHimActive(index) {
      if (this.studentInfo[index].active != true) {
        this.studentInfo.forEach((student) => {
          student.active = false;
        });
        $(".kid").removeClass("active");
        this.studentInfo[index].active = true;
        $(".kid").eq(index).addClass("active");
        this.selectedStudent_id = this.studentInfo[index].student_id;
        this.selectedChild = this.selectedStudent_id;
        this.getAllData();
      } else {
        this.selectedStudent_id = this.studentInfo[index].student_id;
        this.getAllData();
      }
    },
    getMyChildsInfo() {
      axios
        .get(this.getApiUrl + "/dashboard/parent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.studentInfo = response.data.data.student_info;
          // console.log(this.studentInfo);
          this.studentInfo.forEach((student) => {
            student.active = false;
          });
          this.studentInfo[0].active = true;
          this.selectedStudent_id = this.studentInfo[0].student_id;
          this.MakeHimActive(0);
          // this.getSubjects();
        });
    },
    onChildClick(value, item, index) {
      this.AddEditdialog = value;
      if (item != null && index == -1) {
        this.items.push(item);
        this.totalItems = this.totalItems + 1;

        this.length = Math.ceil(this.totalItems / this.options.itemsPerPage);
        if (this.page < this.length) {
          this.page = this.length;
        }
      } else if (index > -1)
        if (item != null) Object.assign(this.items[index], item);
      if (value == false) {
        this.items = [];
        this.$nextTick(function () {
          this.getAllData();
        });
      }
    },

    inputFocus() {
      $("#inpt_search").parent("label").addClass("active");
      $(".input_search").parent("label").addClass("active");
    },
    inputBlur() {
      if (this.search == "") {
        $("#inpt_search").parent("label").removeClass("active");
        $(".input_search").parent("label").removeClass("active");
      }
    },

    getAllData() {
      console.log(this.selectedQuarter, "========");
      var url = "/performance/student-exams-list/" + this.selectedQuarter;
      if (this.parent) {
        url =
          "/performance/parent/" +
          this.selectedStudent_id +
          "/student-exams-list/" +
          this.selectedQuarter;
      }
      axios
        .get(this.getApiUrl + url, {
          // params: {
          //   filter: this.filter,
          // },
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          // this.setPaginationParameters(response);
          // this.totalItems = response.data.data.total;
          // this.items = [];
          this.data = response.data.data.subjectsStudentExams;
          this.generalExams = response.data.data.studentGeneralExams;
          this.showReport = response.data.data.showReport;
          this.loading = false;
          // console.log(Object.keys(this.data).length);
        });
    },
    // setPaginationParameters(response) {
    //   this.length = response.data.data.last_page;
    //   if (this.length > 5) this.totalVisible = 5;
    // },
    getQuarters() {
      axios
        .get(
          this.getApiUrl +
            "/performance/getQuarterFilterBySemester/" +
            this.selectedSemester,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((response) => {
          this.quarters = response.data.data;
          this.quarters.forEach((quarter) => {
            if (quarter.isCurrentQuarterId) {
              if (this.selectedQuarter != quarter.id) {
                this.selectedQuarter = quarter.id;
              } else {
                this.getAllData();
              }
            }
          });
          this.data = [];
          this.showReport = false;
        });
    },
    resetFilterData() {
      this.filter.academic_grade_subject_id = "";
      this.filter.qualifier_id = "";
    },
    // getSubjects() {
    //   //        '/performance/get-student-subjects'
    //   axios
    //     .get(this.getApiUrl + "/performance/get-student-subjects", {
    //       params: {
    //         filter: this.filter,
    //       },
    //       headers: {
    //         Authorization: "Bearer " + localStorage.token,
    //       },
    //     })
    //     .then((response) => {
    //       this.subjects = response.data.data;
    //     });
    // },
    // getQualifiers() {
    //   axios
    //     .get(
    //       this.getApiUrl +
    //         "/performance/get-student-subject-qualifiers/" +
    //         this.filter.quarter_id +
    //         "/" +
    //         this.filter.academic_grade_subject_id,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.token,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       this.qualifierList = response.data.data;
    //     });
    // },
  },
  mounted() {
    if (ACL.Role("Parent")) {
      this.getMyChildsInfo();
    } else {
      // if (this.$route.query.page !== undefined) {
      //   this.page = Number(this.$route.query.page);
      //   this.getAllData(this.page);
      // } else {
      //   this.page = 1;
      //   this.getAllData(this.page);
      // }
    }
    // this.getQuarters();
    // this.getSubjects();
    this.getSemesters();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

#wrapper {
  transition: all 0.4s ease 0s;
}

.main-color {
  color: $main-color;
}
.headerTable-div {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #fff;

  .custom-header {
    margin-bottom: 0;
  }
}

.center {
  margin-left: 30px !important;
}

.select {
  margin-top: 20px !important;
}
.title {
  margin-bottom: 0 !important;
}

.item {
  .item-content {
    .num {
      font-size: 1rem;
      margin: 0;
    }
  }
}

.item1 .item-content .value {
  color: $dashboard-red;
}
.item2 .item-content .value {
  color: $dashbaord-green;
}
.item3 .item-content .value {
  color: $dashboard-purple;
}
.item4 .item-content .value {
  color: $secondary-color;
}

.item .item-content .num {
  font-size: 0.75rem;
}

.item2 .item-content .num {
  color: #000000;
}
.item3 .item-content .num {
  color: #000000;
}
.item4 .item-content .num {
  color: #000000;
}

.main-background {
  background-color: $main-background;
}

.table {
  td {
    border: 0;
    font-size: 1rem;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.add-kids {
  background-color: $main-background;
  display: block;
  width: 100%;
  height: 234px;
  line-height: 200px;
  border-radius: 15px;
}

.kids {
  margin-bottom: 20px;
  margin-top: 20px;
  overflow: hidden;
  .kid {
    border: 1px solid #dddddd;
    background-color: #ffffff;
    border-radius: 10px;
    cursor: pointer;
    height: 140px;
    overflow: hidden;

    .student-image {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .student-name {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      color: #000000;
    }
    .student-grade,
    .student-class {
      color: #000000;
      margin-left: 10px;
    }
  }
  .kid.active {
    background-color: #d8e2ff;
    cursor: default;
  }
}
.title-page {
  margin-top: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.card-container {
  // max-width: 80%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 50px;
}
.card-container .actions {
  position: absolute;
  top: -39px;
  right: 22px;
}
.card-container .actions i,
.card-container .actions span {
  cursor: pointer;
}
.card-container .actions span {
  margin-left: 5px;
}

.title-qualifire .divider {
  margin-top: 10px;
  margin-bottom: 10px;
}
.q-box-title {
  font-size: 29px;
  position: relative;
}

.q-box-title h2 {
  font-size: 25px;
  padding: 0;
  margin: 0;
}

.title-page {
  margin-top: 15px;
}
.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #eef3ff;
  margin-bottom: 33px;
}
.v-expansion-panel-content {
  background-color: #f7f7f7;
}
.title-panel {
  color: rgb(114, 151, 255);
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
.details {
  margin-top: 6%;
  overflow: hidden;
}
.details span {
  color: #8d8a8a;
  font-size: 17px;
  font-weight: 700;
}
.details span.passing {
  float: right;
}
.v-expansion-panel-content__wrap {
  padding: 0;
}
.general-exams .v-expansion-panel {
  background-color: #bbb !important;
}
.general-exams .v-expansion-panel .title-panel {
  color: #444 !important;
}
</style>
